<template>
    <div class="text-container">
        <v-row align-items="center" justify="space-evenly" class="header">
            <v-col style="display: flex; flex-direction: column; align-items: start;">
                <v-btn @click="$emit('close-content')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">{{ item.title }}</p>
            </v-col>
        </v-row>

        <div class="text-content">
            <div v-html="item.content">

            </div>

            <img v-if="item.key == 'rede_social_rede_de_apoio'" style="width: 100%;"
                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/fcf0d1e1-480f-4b80-a2ff-19c1f27dfe8f.png"
                alt="">
            <img v-if="item.key == 'baba_nao_pai_presente'" style="width: 100%;"
                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/0e8a8359-ab63-416e-85a9-6976633ebb01.png"
                alt="">
            <a v-if="listGuia.includes(item.key)" target="_blank" href="//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/guia.pdf">Saiba mais</a>
            <a v-if="parentalidade" target="_blank" href="//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/guia.pdf">Saiba mais</a>
        </div>
    </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';

defineEmits(['close-content'])
defineProps(["item", "parentalidade"])
const listGuia = ['informacoes_importantes', 'licenca', 'outros_tipos_de_licenca', 'por_motivo_de_adocao', 'por_motivo_de_parto', 'licenca_parental_paternidade']

</script>

<style scoped>
.text-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 2;
    background: white;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
}

.submenu-title {
    color: white;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
    margin-top: 7%;
}

.text-content {
    text-align: start;
    margin-top: 15%;
    margin-left: 10%;
    width: 90%;
    height: 55%;
    overflow-y: scroll;
    padding-right: 5%;
}
</style>